export const USER_DATA = 'USER_DATA'

export const ISDETAIL = 'ISDETAIL'
